/*! @azure/msal-common v13.3.3 2024-06-06 */
'use strict';

import { ClientAuthError } from '../error/ClientAuthError.js';
import { StringUtils } from '../utils/StringUtils.js';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * JWT Token representation class. Parses token string and generates claims object.
 */
var AuthToken = /** @class */function () {
  function AuthToken(rawToken, crypto) {
    if (StringUtils.isEmpty(rawToken)) {
      throw ClientAuthError.createTokenNullOrEmptyError(rawToken);
    }
    this.rawToken = rawToken;
    this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
  }
  /**
   * Extract token by decoding the rawToken
   *
   * @param encodedToken
   */
  AuthToken.extractTokenClaims = function (encodedToken, crypto) {
    var decodedToken = StringUtils.decodeAuthToken(encodedToken);
    // token will be decoded to get the username
    try {
      var base64TokenPayload = decodedToken.JWSPayload;
      // base64Decode() should throw an error if there is an issue
      var base64Decoded = crypto.base64Decode(base64TokenPayload);
      return JSON.parse(base64Decoded);
    } catch (err) {
      throw ClientAuthError.createTokenParsingError(err);
    }
  };
  /**
   * Determine if the token's max_age has transpired
   */
  AuthToken.checkMaxAge = function (authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */
    var fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) {
      throw ClientAuthError.createMaxAgeTranspiredError();
    }
  };
  return AuthToken;
}();
export { AuthToken };